(function () {
  document.documentElement.classList.add('ta-js');
  function reveal(root) {
    var els = (root || document).querySelectorAll('.ta-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ta-variant-select]');
    if (!sel) return;
    var form = sel.closest('form');
    var opt = sel.options[sel.selectedIndex];
    var btn = form.querySelector('.ta-card__add');
    if (btn) btn.disabled = opt && opt.dataset.available === 'false';
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ta-quick-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.ta-card__add');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (btn) btn.textContent = 'Added ✓';
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-ta-cart-count], .cart-bubble__text-count').forEach(function (el) { el.textContent = cart.item_count; });
        setTimeout(function () { window.location.href = root + 'cart'; }, 450);
      })
      .catch(function () { form.removeAttribute('data-ta-quick-add'); form.submit(); })
      .finally(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1500); });
  });
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
/* Live polish Oct 19: desktop keyboard scrolling. Horizon's drawer "squeeze" layout makes .page-wrapper the scroll
   container at >=990px (html/body overflow:hidden), so PageDown/Space/arrows did nothing until it was focused.
   When nothing interactive has focus, route those keys to .page-wrapper. Layout and scroll container unchanged. */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  document.addEventListener('keydown', function (e) {
    if (!mq.matches || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement) return;
    var root = document.documentElement;
    if (root.hasAttribute('scroll-lock') || document.querySelector('dialog[open]')) return;
    var w = document.querySelector('.page-wrapper');
    if (!w || w.scrollHeight <= w.clientHeight) return;
    var page = Math.max(40, w.clientHeight - 80), k = e.key, d = null;
    if (k === 'PageDown' || (k === ' ' && !e.shiftKey)) d = page;
    else if (k === 'PageUp' || (k === ' ' && e.shiftKey)) d = -page;
    else if (k === 'ArrowDown') d = 60;
    else if (k === 'ArrowUp') d = -60;
    else if (k === 'Home') { e.preventDefault(); w.scrollTo({ top: 0 }); return; }
    else if (k === 'End') { e.preventDefault(); w.scrollTo({ top: w.scrollHeight }); return; }
    if (d !== null) { e.preventDefault(); w.scrollBy({ top: d }); }
  });
})();
